import http from './httpClient';

const analyticsApiService = {
  // Получение общей статистики
  getOverallStats: async (params = {}) => {
    const response = await http.get('/api/orders/analytics/overall-stats/', { params });
    return response.data;
  },

  // Получение данных для графиков продаж по дням
  getDailySalesData: async (params = {}) => {
    const response = await http.get('/api/orders/analytics/daily-sales/', { params });
    return response.data;
  },

  // Получение популярных блюд
  getPopularDishes: async (params = {}) => {
    const response = await http.get('/api/orders/analytics/popular-dishes/', { params });
    return response.data;
  },

  // Получение данных для графиков выручки по месяцам
  getMonthlyRevenueData: async (params = {}) => {
    const response = await http.get('/api/orders/analytics/monthly-revenue/', { params });
    return response.data;
  },

  // Получение статистики заказов
  getOrdersAnalytics: async (params = {}) => {
    const response = await http.get('/api/orders/analytics/orders/', { params });
    return response.data;
  },

  // Получение статистики по времени заказов
  getOrderTimeStats: async (params = {}) => {
    const response = await http.get('/api/orders/analytics/order-time/', { params });
    return response.data;
  },

  // Получение статистики по способам оплаты
  getPaymentMethodStats: async (params = {}) => {
    const response = await http.get('/api/orders/analytics/payment-methods/', { params });
    return response.data;
  },

  // Получение статистики по типам заказов
  getOrderTypeStats: async (params = {}) => {
    const response = await http.get('/api/orders/analytics/order-types/', { params });
    return response.data;
  },

  // Получение статистики пользователей
  getUsersAnalytics: async (params = {}) => {
    const response = await http.get('/api/orders/analytics/users/', { params });
    return response.data;
  },

  // Получение списка заведений
  getEstablishments: async () => {
    const response = await http.get('/api/orders/analytics/establishments/');
    return response.data;
  },

  // Экспорт отчета
  exportReport: async (params = {}) => {
    const response = await http.get('/api/orders/analytics/export/', {
      params,
      responseType: 'blob'
    });
    return response.data;
  }
};

export default analyticsApiService; 